import localizationConstants from "constants/localization";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import localizationUtils from "utils/localization";

const { RESOURCES, REGIONS } = localizationConstants;

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: RESOURCES,
    lng: localizationUtils.getCurrentLanguage(),
    fallbackLng: REGIONS.vi.key,

    interpolation: {
      escapeValue: false,
    },

    // Namespace configuration (to support seller specific translations)
    // NOTE: add new namespace for new seller here
    ns: ["translation", "pv", "sgc"],
    // default namespace used if not specified
    fallbackNS: "translation",
  });

export default i18n;
